import { postDocumentFile } from '~/src/repositories/document-upload/document-upload.repository';

export const DocumentUploadService = {
    postDocumentFile,
};
